<div class="tree-select-container" [class.has-selection]="selectedNode">
  <mat-form-field appearance="fill">
    <mat-label>{{ label }}</mat-label>
    <input
      matInput
      [value]="selectedNode ? getName(selectedNode) : ''"
      readonly
      (click)="togglePanel(); $event.preventDefault(); $event.stopPropagation()"
      [placeholder]="'Select a category...'"
    />
    <button *ngIf="selectedNode" mat-icon-button matSuffix type="button" tabindex="-1" (click)="clearSelection(); $event.stopPropagation(); $event.preventDefault()">
      <mat-icon>close</mat-icon>
    </button>
  </mat-form-field>
  <div class="tree-select-arrow-wrapper" (click)="togglePanel(); $event.preventDefault(); $event.stopPropagation()">
    <div class="tree-select-arrow">
      <svg viewBox="0 0 24 24" width="24px" height="24px" focusable="false" aria-hidden="true">
        <path d="M7 10l5 5 5-5z"/>
      </svg>
    </div>
  </div>
  <div class="tree-select-panel" *ngIf="isPanelOpen" (click)="$event.stopPropagation()">
    <mat-tree [dataSource]="dataSource" [treeControl]="treeControl">
      <mat-tree-node *matTreeNodeDef="let node">
        <div class="mat-tree-node" [matTreeNodePadding]="true" [matTreeNodePaddingIndent]="22" (click)="selectNode(node); $event.stopPropagation()">
          <div class="mat-tree-node-spacer"></div>
          <div class="mat-tree-node-content" [class.selected]="selectedNode && getId(selectedNode) === getId(node)" [attr.id]="selectedNode && getId(selectedNode) === getId(node) ? 'selected-tree-node' : null">
            {{ getName(node) }}
          </div>
        </div>
      </mat-tree-node>
      <mat-nested-tree-node *matTreeNodeDef="let node; when: hasChild">
        <div class="mat-tree-node" [matTreeNodePadding]="true" [matTreeNodePaddingIndent]="16">
          <button mat-icon-button matTreeNodeToggle type="button" [attr.aria-label]="'Toggle ' + getName(node)" (click)="$event.stopPropagation(); $event.preventDefault()">
            <mat-icon class="mat-icon-rtl-mirror">
              {{treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right'}}
            </mat-icon>
          </button>
          <div class="mat-tree-node-content" (click)="selectNode(node); $event.stopPropagation()" [class.selected]="selectedNode && getId(selectedNode) === getId(node)" [attr.id]="selectedNode && getId(selectedNode) === getId(node) ? 'selected-tree-node' : null">
            {{ getName(node) }}
          </div>
        </div>
        <div [class.mat-tree-invisible]="!treeControl.isExpanded(node)" role="group">
          <ng-container matTreeNodeOutlet></ng-container>
        </div>
      </mat-nested-tree-node>
    </mat-tree>
  </div>
</div>
